import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ElementRef,
  SimpleChanges,
} from '@angular/core';
import { UiFactory } from '../../core/ui/ui-factory';
import { TextContentModel } from './text-content-model';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { TemplateProcessor } from '../../core/text/template-processor';

@Component({
  selector: 'pg-text-content-factory, grit-text-content-factory',
  templateUrl: './pg-text-content-factory.component.html',
  styleUrls: ['./pg-text-content-factory.component.scss'],
})
export class PgTextContentFactoryComponent extends UiFactory {
  @Input() model: any;
  links = [];

  get textContentModel(): TextContentModel {
    return this.model;
  }

  get hostEl(): HTMLElement {
    return this.elementRef.nativeElement;
  }
  constructor(
    public elementRef: ElementRef,
    public behaviorService: BehaviorService,
    public templateProcessor: TemplateProcessor
  ) {
    super(behaviorService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.textContentModel.template) {
      this.textContentModel.content = this.templateProcessor.proccessTemplate(
        this.textContentModel.template,
        this.behaviorService.globalContext
      );
    }
  }
}
